export default function indexOfMessages(validationErrors) {
  let allIndex = validationErrors.map(err => {
    const closeIndex = err.members[0].indexOf(']');
    if (!closeIndex) return null;
    const index = err.members[0].substring(1, closeIndex);
    if (!index) return null;
    try {
      return Number(index);
    } catch (e) {
      return null;
    }
  });
  allIndex = [...new Set(allIndex.filter(i => i !== null))];
  return allIndex.map(i => {
    return {
      numLigne: i,
      errors: {
        data: {
          error: {
            validationErrors: validationErrors.filter(err => err.members[0].startsWith(`[${i}]`)),
          },
        },
      },
    };
  });
}
